import React, { useState } from 'react';
import TwoColumns from '~/components/TwoColumns';
import TextCard from '~/components/Dynamic/TextCard';
import Image from '~/components/Dynamic/Image';
import Accordion from '~/components/Dynamic/Accordion';

function AccordionTwoColumn({ blok }) {
  const [activeItem, setActiveItem] = useState(0);
  return (
    <section className="my-20 md:my-28">
      <div className="container">
        <TwoColumns
          text={
            <div className="max-w-md">
              <div className="md:mb-8">
                <TextCard blok={blok.textCard[0]} />
              </div>
              <div className="hidden md:block">
                <Accordion items={blok.items} activeItem={activeItem} setActiveItem={setActiveItem} />
              </div>
            </div>
          }
          image={
            <div className="w-full -mt-6 md:h-full md:mt-0">
              <div className="w-full md:h-full">
                {blok.items[activeItem]?.image && (
                  <Image
                    blok={blok.items[activeItem].image}
                    className="object-contain w-full h-full"
                    imageClassName="h-full w-full object-contain"
                  />
                )}
              </div>
              <div className="mt-10 md:hidden">
                <Accordion items={blok.items} activeItem={activeItem} setActiveItem={setActiveItem} />
              </div>
            </div>
          }
        />
      </div>
    </section>
  );
}

export default AccordionTwoColumn;
